export default "__VITE_ASSET__Cj53F2b9__"